
































































































































































































































































































































































































































































































































































































































































































































































































































































import {
    Component,
    Prop,
    Vue
} from "vue-property-decorator";

import moment from "moment";

import {
    BModal,
    BButton,
    BFormDatepicker
} from "bootstrap-vue";

@Component({
    components: {
        BModal,
        BButton,
        BFormDatepicker
    }
})
export default class MultiAppointmentConflictModal
    extends Vue {

    @Prop()
    result!: any;

    @Prop()
    calendarId!: number;

    @Prop()
    calendar!: any;

    moment = moment;

    conflicts: any[] = [];

    mounted() {

        this.conflicts =
            this.result.Appointments
                .filter(
                    x =>
                        !x.Available
                )
                .map(
                    x => ({

                        ...x,

                        NewDate:
                            moment(
                                x.Date
                            ).format(
                                "YYYY-MM-DD"
                            ),

                        NewTime:
                            "",

                        TimeOptions:
                            []

                    })
                );

        this.conflicts.forEach(
            x =>
                this.loadTimes(
                    x
                )
        );

    }

    close() {

        this.$emit(
            "close"
        );

    }

    applyChanges() {

    const invalid =
        this.conflicts.some(
            x =>
                !x.NewDate ||
                !x.NewTime
        );

    if (invalid) {

        this.$bvToast.toast(
            "Please select a date and time for all conflicts.",
            {
                title:
                    "Validation",

                variant:
                    "warning",

                solid:
                    true
            }
        );

        return;
    }

    const appointments =
        this.result.Appointments.map(
            appt => {

                const updated =
                    this.conflicts.find(
                        x =>
                            x.Index ===
                            appt.Index
                    );

                return {

                    Index:
                        appt.Index,

                    Date:
                        updated
                            ? updated.NewDate
                            : moment(
                                appt.Date
                              ).format(
                                "YYYY-MM-DD"
                              ),

                    Time:
                        updated
                            ? updated.NewTime
                            : appt.Time

                };

            }
        );

    this.$emit(
        "apply",
        appointments
    );

    this.close();
}

    applyChanges20260608() {

        const invalid =
            this.conflicts.some(
                x =>
                    !x.NewDate ||
                    !x.NewTime
            );

        if (invalid) {

            this.$bvToast.toast(
                "Please select a date and time for all conflicts.",
                {
                    title:
                        "Validation",

                    variant:
                        "warning",

                    solid:
                        true
                }
            );

            return;

        }

        const conflicts =
            this.conflicts.map(
                x => ({

                    Index:
                        x.Index,

                    Date:
                        x.NewDate,

                    Time:
                        x.NewTime

                })
            );

        this.$emit(
            "apply",
            conflicts
        );

        this.close();

    }

    createOnlyValid() {

    this.$emit(
        "create-only-valid"
    );

}

createAll() {

    this.$emit(
        "create-all"
    );

}

    async loadTimes(
        item: any
    ) {

        item.TimeOptions =
            [];

        item.NewTime =
            "";

        try {

            const times =
                await this.$store.dispatch(
                    "schedule/getCalendarTimes",
                    {
                        calendarId:
                            this.calendarId,

                        date:
                            item.NewDate
                    }
                );

            item.TimeOptions =
                times
                    .filter(
                        x =>
                            !x.disabled
                    )
                    .map(
                        x => ({

                            value:
                                x.time,

                            text:
                                moment(
                                    x.time,
                                    "HH:mm:ss"
                                ).format(
                                    "hh:mm A"
                                )

                        })
                    );

        } catch (ex) {

            console.error(
                ex
            );

        }

    }

    isDisabledDate(ymd: string, date: Date) {
        if (this.calendar.dates.length) {
            const weekday = moment(date).format("ddd").toUpperCase();
            let disabled = true;
            this.calendar.dates.forEach((item) => {
                if (item.date === "1900-01-01" && item.weekday === weekday) {
                    disabled = item.disabled;
                } else if (item.date === ymd) {
                    disabled = item.disabled;
                }
            });
            return disabled;
        } else {
            return false;
        }
    }
    getDateClass(ymd: string, date: Date) {
        if (this.calendar.fullDates.includes(ymd)) {
            return "full-date";
        }
        return null;
    }

  get hasChanges(): boolean {

    return this.conflicts.some(
        x =>
            x.NewDate &&
            x.NewTime &&
            (
                x.NewDate !== x.Date ||
                x.NewTime !== x.Time
            )
    );
}

}
